"use strict";
exports.__esModule = true;
exports.getColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var data_1 = require("../helpers/geoChart/data");
var GeoChartColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(GeoChartColorStrategy, _super);
    function GeoChartColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GeoChartColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    locationAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    segmentByAttribute, dv) {
        // color follows SegmentBy
        if (segmentByAttribute) {
            return {
                fullColorAssignment: this.getColorStrategyForSegmentBy(colorPalette, colorMapping, segmentByAttribute, dv)
            };
        }
        // color follows Location
        return {
            fullColorAssignment: [
                this.getColorStrategyForLocation(colorPalette, colorMapping, locationAttribute, dv),
            ]
        };
    };
    GeoChartColorStrategy.prototype.getColorStrategyForSegmentBy = function (colorPalette, colorMapping, segmentByAttribute, dv) {
        var colorStrategy = new sdk_ui_vis_commons_1.AttributeColorStrategy(colorPalette, colorMapping, null, segmentByAttribute, dv);
        return colorStrategy.getColorAssignment();
    };
    GeoChartColorStrategy.prototype.getColorStrategyForLocation = function (colorPalette, colorMapping, locationAttribute, dv) {
        var mappedColor = sdk_ui_vis_commons_1.getColorFromMapping(locationAttribute, colorMapping, dv);
        var color = mappedColor !== undefined && sdk_ui_vis_commons_1.isValidMappedColor(mappedColor, colorPalette)
            ? mappedColor
            : {
                type: "guid",
                value: colorPalette[0].guid
            };
        return {
            headerItem: locationAttribute,
            color: color
        };
    };
    return GeoChartColorStrategy;
}(sdk_ui_vis_commons_1.ColorStrategy));
function getColorStrategy(colorPalette, colorMapping, geoData, dv) {
    var _a = data_1.findGeoAttributesInDimension(dv, geoData), locationAttribute = _a.locationAttribute, segmentByAttribute = _a.segmentByAttribute;
    var locationAttributeHeader = {
        attributeHeader: omit_1["default"](locationAttribute, "items")
    };
    return new GeoChartColorStrategy(colorPalette, colorMapping, locationAttributeHeader, segmentByAttribute, dv);
}
exports.getColorStrategy = getColorStrategy;
//# sourceMappingURL=geoChart.js.map